import { createI18n } from 'vue-i18n'

import JaMessages from './locales/ja/translation'
import EnMessages from './locales/en/translation'

export default createI18n({
  // legacy: false (Composition APIモード) でも globalInjection (デフォルトtrue) により
  // Options APIコンポーネントでの this.$t 等はそのまま使用できるため、
  // 非推奨警告([intlify] Legacy API mode has been deprecated)を避けるためfalseにする
  legacy: false,
  locale: 'ja',
  // ロケール設定用の翻訳定義がない場合は、日本語を使用する。
  fallbackLocale: 'ja',
  messages: {
    ja: JaMessages.ja,
    en: EnMessages.en,
  },
  // 翻訳メッセージにHTML（開発者が管理する固定文言、ユーザー入力ではない）を
  // 含めている箇所があるため、vue-i18nのXSS対策の警告(コンソール出力のみ)を抑制する
  // (legacy: false モードでは文字列の warnHtmlInMessage ではなく、
  //  真偽値の warnHtmlMessage を使う必要がある)
  warnHtmlMessage: false,
});